import React from "react";

import ruler from '../../Assets/Images/ruler.svg';
import navigate from '../../Assets/Images/navigate.svg';
import Likert from "../Charts/Likert/Likert";

const LikertSection = ({ data, responses }) => {

	const left_labels = [
		{
			label: 0,
			color: '#E0510D'
		},
		{
			label: 1,
			color: '#F48956'
		},
		{
			label: 2,
			color: '#F8C9B4'
		}
	];

	const right_labels = [
		{
			label: 3,
			color: '#DDEBA9'
		},
		{
			label: 4,
			color: '#ACC549'
		},
		{
			label: 5,
			color: '#7D8704'
		}
	];


	return (
		<tbody>
			<tr>
				<td className="index">
					<div className="contents">
						<span>#{data.id}</span>
						{data.section}
					</div>
				</td>
				<td>
					<div className="ruler">
						<img src={ruler} alt="ruler" />
						<p>Agreement</p>
					</div>
				</td>
				<td >
					<div className="average">
						4.2
					</div>
				</td>

				<td className="segment-bar-container" >
					{/* <div className="segment-bar">
						<div className="likert-bar"></div>
						<div className="marker" style={{ left: data?.markerPosition }}></div>
					</div> */}
					<Likert left_labels={left_labels} right_labels={right_labels} responses={responses} />
				</td>
				<td className="highest-score">
					<div className="contents">
						<div className="average">
							4.2
						</div>
						Serving Others
					</div>
				</td>
				<td >
					<div className="contents">
						<div className="lowest-score">1.5</div>
						Comfort Identifying
					</div>

				</td>
				<td>
					<img src={navigate} alt="navigate" />
				</td>
			</tr>
		</tbody>
	);
};

export default LikertSection;
